'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _graphql = require('graphql');

require('graphiql/graphiql.css');

var _graphiql = require('graphiql');

var _graphiql2 = _interopRequireDefault(_graphiql);

var _debounce = require('graphiql/dist/utility/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _find = require('graphiql/dist/utility/find');

var _find2 = _interopRequireDefault(_find);

var _getQueryFacts = require('graphiql/dist/utility/getQueryFacts');

var _getQueryFacts2 = _interopRequireDefault(_getQueryFacts);

var _getSelectedOperationName = require('graphiql/dist/utility/getSelectedOperationName');

var _getSelectedOperationName2 = _interopRequireDefault(_getSelectedOperationName);

var _ExecuteButton = require('graphiql/dist/components/ExecuteButton');

var _ToolbarButton = require('graphiql/dist/components/ToolbarButton');

var _VariableEditor = require('graphiql/dist/components/VariableEditor');

var _ResultViewer = require('graphiql/dist/components/ResultViewer');

var _QueryHistory = require('graphiql/dist/components/QueryHistory');

var _QueryEditor = require('graphiql/dist/components/QueryEditor');

var _DocExplorer = require('graphiql/dist/components/DocExplorer');

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _graphqlLanguageServiceInterface = require('graphql-language-service-interface');

var _UI = require('./UI');

var _UI2 = _interopRequireDefault(_UI);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import QueryEditor from "./QueryEditor";
// import DocExplorer from "./DocExplorer";


var styles = {
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "& .graphiql-container .topBar, & .graphiql-container .doc-explorer-title-bar, & .graphiql-container .history-title-bar": {
      height: 48
    },
    "& .graphiql-container .doc-explorer-title, .graphiql-container .history-title": {
      userSelect: "all"
    }
  }
};

var QueryBuilder = function (_GraphiQL) {
  _inherits(QueryBuilder, _GraphiQL);

  function QueryBuilder() {
    var _temp, _this, _ret;

    _classCallCheck(this, QueryBuilder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _GraphiQL.call.apply(_GraphiQL, [this].concat(args))), _this), _this.handleEditQuery = (0, _debounce2.default)(100, function (value, callback) {
      var onEditQuery = _this.props.onEditQuery;
      var _this$state = _this.state,
          operationName = _this$state.operationName,
          operations = _this$state.operations,
          schema = _this$state.schema;
      var queryFacts = void 0;

      try {
        queryFacts = _this._updateQueryFacts(value, operationName, operations, schema);
      } catch (error) {
        console.error(error);
      }

      _this.setState(_extends({
        query: value
      }, queryFacts), callback);

      if (onEditQuery) {
        try {
          onEditQuery(value);
        } catch (error) {
          console.error(error);
        }
      }
    }), _this._updateQueryFacts = function (query, operationName, prevOperations, schema) {
      var queryFacts = (0, _getQueryFacts2.default)(schema, query);

      if (queryFacts) {
        // Update operation name should any query names change.
        var updatedOperationName = (0, _getSelectedOperationName2.default)(prevOperations, operationName, queryFacts.operations); // Report changing of operationName if it changed.

        var onEditOperationName = _this.props.onEditOperationName;

        if (onEditOperationName && operationName !== updatedOperationName) {
          onEditOperationName(updatedOperationName);
        }

        return _extends({
          operationName: updatedOperationName
        }, queryFacts);
      }
    }, _this.handlePrettifyQuery = function () {
      try {
        var editor = _this.getQueryEditor();

        editor.setValue((0, _graphql.print)((0, _graphql.parse)(editor.getValue())));
      } catch (error) {// console.error(error);
      }
    }, _this.handleHintInformationRender = function (elem) {
      var editor = _this.queryEditorComponent.editor;
      var schema = _this.state.schema;

      if (!schema) {
        return;
      }

      var cur = editor.getCursor();
      var token = editor.getTokenAt(cur);
      var rawResults = (0, _graphqlLanguageServiceInterface.getAutocompleteSuggestions)(schema, editor.getValue(), cur, token);
      /**
       * GraphQL language service responds to the autocompletion request with
       * a different format:
       * type CompletionItem = {
       *   label: string,
       *   kind?: number,
       *   detail?: string,
       *   documentation?: string,
       *   // GraphQL Deprecation information
       *   isDeprecated?: ?string,
       *   deprecationReason?: ?string,
       * };
       *
       * Switch to codemirror-compliant format before returning results.
       */

      var tokenStart = token.type !== null && /"|\w/.test(token.string[0]) ? token.start : token.end;
      var results = {
        list: rawResults.map(function (item) {
          return {
            text: item.label,
            type: schema.getType(item.detail),
            description: item.documentation,
            isDeprecated: item.isDeprecated,
            deprecationReason: item.deprecationReason
          };
        }),
        from: {
          line: cur.line,
          column: tokenStart
        },
        to: {
          line: cur.line,
          column: token.end
        }
      };

      if (results && results.list && results.list.length > 0) {// results.from = CodeMirror.Pos(results.from.line, results.from.column);
        // results.to = CodeMirror.Pos(results.to.line, results.to.column);
        // CodeMirror.signal(editor, 'hasCompletion', editor, results, token);
      }

      elem.addEventListener('click', _this._onClickHintInformation);

      var _onRemoveFn = void 0;

      elem.addEventListener('DOMNodeRemoved', _onRemoveFn = function onRemoveFn() {
        elem.removeEventListener('DOMNodeRemoved', _onRemoveFn);
        elem.removeEventListener('click', _this._onClickHintInformation);
      });
    }, _this._onClickHintInformation = function (event) {
      if (event.target.className === 'typeName') {
        var typeName = event.target.innerHTML;
        var schema = _this.state.schema;

        if (schema) {
          var type = schema.getType(typeName);

          if (type) {
            _this.setState({
              docExplorerOpen: true
            }, function () {
              _this.docExplorerComponent.showDoc(type);
            });
          }
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // static propTypes = {
  //   ...GraphiQL.propTypes,
  //   schema: PropTypes.object.isRequired,
  // };


  QueryBuilder.prototype.addQuery = function addQuery(newQuery) {
    var query = this.state.query;
    newQuery = '\n      ' + query + '\n\n      ' + newQuery + '\n\n    ';
    return this.setQuery(newQuery);
  };

  QueryBuilder.prototype.setQuery = function setQuery(query) {
    var _this2 = this;

    try {
      this.handleEditQuery(query, function () {
        return _this2.handlePrettifyQuery();
      });
    } catch (error) {// console.error(error);
      // throw error;
    }
  }; // handleEditorRunQuery = () => {
  //   this._runQueryAtCursor();
  // };


  QueryBuilder.prototype._render = function _render() {
    var _this3 = this;

    var view = this.props.view;
    var _state = this.state,
        query = _state.query,
        schema = _state.schema;

    var children = _react2.default.Children.toArray(this.props.children);

    var logo = (0, _find2.default)(children, function (child) {
      return child.type === _graphiql2.default.Logo;
    }) || _react2.default.createElement(_graphiql2.default.Logo, null);

    var toolbar = (0, _find2.default)(children, function (child) {
      return child.type === _graphiql2.default.Toolbar;
    }) || _react2.default.createElement(_graphiql2.default.Toolbar, null, _react2.default.createElement(_ToolbarButton.ToolbarButton, {
      onClick: this.handlePrettifyQuery,
      title: 'Prettify Query (Shift-Ctrl-P)',
      label: 'Prettify'
    }), _react2.default.createElement(_ToolbarButton.ToolbarButton, {
      onClick: this.handleToggleHistory,
      title: 'Show History',
      label: 'History'
    }));

    var footer = (0, _find2.default)(children, function (child) {
      return child.type === _graphiql2.default.Footer;
    });
    var queryWrapStyle = {
      WebkitFlex: this.state.editorFlex,
      flex: this.state.editorFlex
    };
    var docWrapStyle = {
      display: this.state.docExplorerOpen ? 'block' : 'none',
      width: this.state.docExplorerWidth
    };
    var docExplorerWrapClasses = 'docExplorerWrap' + (this.state.docExplorerWidth < 200 ? ' doc-explorer-narrow' : '');
    var historyPaneStyle = {
      display: this.state.historyPaneOpen ? 'block' : 'none',
      width: '230px',
      zIndex: '7'
    };
    var variableOpen = this.state.variableEditorOpen;
    var variableStyle = {
      height: variableOpen ? this.state.variableEditorHeight : null
    };
    return _react2.default.createElement('div', {
      className: 'graphiql-container'
    }, _react2.default.createElement('div', {
      className: 'historyPaneWrap',
      style: historyPaneStyle
    }, _react2.default.createElement(_QueryHistory.QueryHistory, {
      operationName: this.state.operationName,
      query: this.state.query,
      variables: this.state.variables,
      onSelectQuery: this.handleSelectHistoryQuery,
      storage: this._storage,
      queryID: this._editorQueryID
    }, _react2.default.createElement('div', {
      className: 'docExplorerHide',
      onClick: this.handleToggleHistory
    }, "\u2715"))), _react2.default.createElement('div', {
      className: 'editorWrap'
    }, _react2.default.createElement('div', {
      className: 'topBarWrap'
    }, _react2.default.createElement('div', {
      className: 'topBar'
    }, logo, _react2.default.createElement(_ExecuteButton.ExecuteButton, {
      isRunning: Boolean(this.state.subscription),
      onRun: this.handleRunQuery,
      onStop: this.handleStopQuery,
      operations: this.state.operations
    }), toolbar), !this.state.docExplorerOpen && _react2.default.createElement('button', {
      className: 'docExplorerShow',
      onClick: this.handleToggleDocs
    }, 'Docs')), _react2.default.createElement('div', {
      ref: function ref(n) {
        _this3.editorBarComponent = n;
      },
      className: 'editorBar',
      onDoubleClick: this.handleResetResize,
      onMouseDown: this.handleResizeStart
    }, _react2.default.createElement('div', {
      className: 'queryWrap',
      style: queryWrapStyle
    }, _react2.default.createElement(_QueryEditor.QueryEditor, {
      ref: function ref(n) {
        _this3.queryEditorComponent = n;
      },
      schema: this.state.schema,
      value: this.state.query,
      onEdit: this.handleEditQuery,
      onHintInformationRender: this.handleHintInformationRender,
      onClickReference: this.handleClickReference,
      onPrettifyQuery: this.handlePrettifyQuery,
      onRunQuery: this.handleEditorRunQuery,
      editorTheme: this.props.editorTheme
    }), _react2.default.createElement('div', {
      className: 'variable-editor',
      style: variableStyle
    }, _react2.default.createElement('div', {
      className: 'variable-editor-title',
      style: {
        cursor: variableOpen ? 'row-resize' : 'n-resize'
      },
      onMouseDown: this.handleVariableResizeStart
    }, 'Query Variables'), _react2.default.createElement(_VariableEditor.VariableEditor, {
      ref: function ref(n) {
        _this3.variableEditorComponent = n;
      },
      value: this.state.variables,
      variableToType: this.state.variableToType,
      onEdit: this.handleEditVariables,
      onHintInformationRender: this.handleHintInformationRender,
      onPrettifyQuery: this.handlePrettifyQuery,
      onRunQuery: this.handleEditorRunQuery,
      editorTheme: this.props.editorTheme
    }))), _react2.default.createElement('div', {
      className: 'resultWrap'
    }, this.state.isWaitingForResponse && _react2.default.createElement('div', {
      className: 'spinner-container'
    }, _react2.default.createElement('div', {
      className: 'spinner'
    })), _react2.default.createElement(_UI2.default, {
      ref: function ref(c) {
        _this3.resultComponent = c;
      },
      value: this.state.response,
      editorTheme: this.props.editorTheme,
      ResultsTooltip: this.props.ResultsTooltip,
      schema: schema,
      query: query,
      setQuery: function setQuery(query) {
        return _this3.setQuery(query);
      },
      view: view
    }), footer))), _react2.default.createElement('div', {
      className: docExplorerWrapClasses,
      style: docWrapStyle
    }, _react2.default.createElement('div', {
      className: 'docExplorerResizer',
      onDoubleClick: this.handleDocsResetResize,
      onMouseDown: this.handleDocsResizeStart
    }), _react2.default.createElement(_DocExplorer.DocExplorer, {
      ref: function ref(c) {
        _this3.docExplorerComponent = c;
      },
      schema: schema,
      query: query,
      setQuery: function setQuery(query) {
        return _this3.setQuery(query);
      }
    }, _react2.default.createElement('div', {
      className: 'docExplorerHide',
      onClick: this.handleToggleDocs
    }, "\u2715"))));
  };

  QueryBuilder.prototype.render = function render() {
    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, this._render());
  };

  return QueryBuilder;
}(_graphiql2.default);

exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(QueryBuilder, props);
});
module.exports = exports['default'];